import { render, staticRenderFns } from "./roleEditDialog.vue?vue&type=template&id=6c84c5ec&scoped=true&"
import script from "./roleEditDialog.vue?vue&type=script&lang=js&"
export * from "./roleEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./roleEditDialog.vue?vue&type=style&index=0&id=6c84c5ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c84c5ec",
  null
  
)

export default component.exports